
<div class="card bg-white">
    <div class="card-header">
        <i class="fa fa-leanpub"></i> Crear solicitudes de crédito
      </div>
    <div class="card-body card-body-z-index">
        <iframe id="frameCreateCreditRequest" sandbox="allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation" [src]="oldPosUrl|safe"></iframe>
    </div>
</div>